export default __webpack_public_path__ + "static/1584-7f7625c23d16f33dd5ec4250a0543c2e.gif";